<template>
    <div class="home-hot">
        <div class="hot-name" v-if="ysItem.isName==0">—— {{ysItem.gnName}} ——</div>
        <div v-for="item in items">
            <Style1 v-if="item.styleNum == 1" :imgMap="item.imgMap"/>
            <Style2 v-if="item.styleNum == 2" :imgMap="item.imgMap"/>
            <Style3 v-if="item.styleNum == 3" :imgMap="item.imgMap"/>
            <Style4 v-if="item.styleNum == 4" :imgMap="item.imgMap"/>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";
    import Style1 from "../style/style1";
    import Style2 from "../style/style2";
    import Style3 from "../style/style3";
    import Style4 from "../style/style4";
    export default {
        components: {
            Style1,
            Style2,
            Style3,
            Style4,
        },
        data() {
            return {
                deptId: '',
                phone: '',
                bps: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleItems()
        },
        methods: {
            async getStyleItems() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmStyleItems", data)
                this.items = res.list
            },
        },
    };
</script>

<style lang="scss" scoped>
    .home-hot {
        height: 100%;
        margin: 0 5px 5px 5px;
    }
    .hot-name{
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        padding: 18px 0;
    }

    .bps-items {
        display: flex;
        flex-flow: row wrap;
        font-size: 10px;
    }

    .bps-item {
        box-sizing: border-box;
        margin: 9px 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc((100% - 44px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 44px) / 2);
        max-width: calc((100% - 44px) / 2);
    }

</style>
